import React from 'react'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import { withStyles } from 'material-ui/styles'
import { connect } from 'react-redux'
import { saveFundAndRefreshBalance } from '../actions/fund'
import * as selectors from 'selectors'
import SelectCrypto from 'components/fields/SelectCrypto'
import { Field, reduxForm, FieldArray } from 'redux-form'
import TextField from 'components/fields/TextField'
import HashesArray from 'components/fields/HashesArray'
import { requiredFieldsValidatorFactory } from 'utils/validators'
import CheckIcon from 'material-ui-icons/Check'
import CloseIcon from 'material-ui-icons/Close'
import IconButton from 'material-ui/IconButton'
import compose from 'recompose/compose'
import { get } from 'lodash'

const styles = {
  cardActions: {
    justifyContent: 'flex-end',
  },
}

const SUPPORTED_HASH = ['ETH', 'BTC']

class FundHashForm extends React.Component {
  render() {
    const { classes, onExit, handleSubmit } = this.props
    return (
      <form onSubmit={handleSubmit}>
        <Card className={classes.card}>
          <CardActions className={classes.cardActions}>
            <IconButton onClick={onExit}>
              <CloseIcon />
            </IconButton>
            <IconButton color="primary" type="submit">
              <CheckIcon />
            </IconButton>
          </CardActions>
          <CardContent>
            <div>
              <Field
                name="currency"
                component={SelectCrypto}
                cryptos={SUPPORTED_HASH}
                autoFocus
                label="Crypto currency"
              />
            </div>
            <div>
              <FieldArray name="hashes" component={HashesArray} />
            </div>
            <div>
              <Field
                name="description"
                component={TextField}
                label="description"
              />
            </div>
          </CardContent>
        </Card>
      </form>
    )
  }
}

FundHashForm.muiName = 'Card'

const mapStateToProps = (state, ownProps) => ({
  form: ownProps.name,
  mainCurrency: selectors.mainCurrency(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: ({ currency, hashes, description }) => {
    dispatch(
      saveFundAndRefreshBalance({
        _uid: get(ownProps, 'initialValues._uid'),
        type: 'hash',
        currency,
        hashes,
        description,
      })
    )
  },
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    validate: requiredFieldsValidatorFactory(['currency', 'hashes']),
    onSubmitSuccess: (result, dispatch, props) =>
      props.onExit && props.onExit(),
  })
)(FundHashForm)



// WEBPACK FOOTER //
// ./src/components/FundHashForm.js